import type { TraceSource } from './types'

/**
 * Слова диагностики продаж. Участки времени и источники точек — закрытый словарь договора со службой; незнакомый ключ (служба
 * новее клиента) показывается так, как его назвала служба.
 */

/** Название участка и пояснение «что это». */
export const SEGMENT_WORDS: Readonly<Record<string, { label: string; hint: string }>> = {
  browser: { label: 'Браузер кассира', hint: 'очередь корзины, проверка связи, отрисовка окна' },
  network: { label: 'Интернет кассира', hint: 'дорога запроса от браузера до нашего сервера и обратно' },
  server: { label: 'Наш сервер', hint: 'подготовка и отправка операции в кабинет AQSI' },
  'cabinet-to-register': { label: 'Кабинет AQSI → касса', hint: 'доставка команды до кассы: облако AQSI и интернет кассы' },
  terminal: { label: 'Терминал и покупатель', hint: 'покупатель прикладывает карту, терминал связывается с банком' },
  'register-receipt': { label: 'Касса: чек', hint: 'запись в фискальный накопитель и печать чека' },
}

/** Знак участка рядом с цветом: состояние не должно различаться только цветом. */
export const SEGMENT_MARKS: Readonly<Record<string, string>> = {
  browser: 'Б',
  network: 'И',
  server: 'С',
  'cabinet-to-register': 'К',
  terminal: 'Т',
  'register-receipt': 'Ч',
}

export function segmentLabel(key: string, serviceLabel: string): string {
  return SEGMENT_WORDS[key]?.label ?? serviceLabel
}

export const SOURCE_WORDS: Readonly<Record<TraceSource, string>> = {
  browser: 'Браузер',
  server: 'Наш сервер',
  cabinet: 'Кабинет AQSI',
  register: 'Касса',
}

/** Этапы браузера (закрытый словарь клиента и сервера); этапы сервера, кабинета и кассы показываются как пришли. */
export const BROWSER_STAGE_WORDS: Readonly<Record<string, string>> = {
  click: 'Нажатие «Картой» или «Наличными»',
  'cart-queue-wait': 'Ожидание очереди корзины',
  probe: 'Проверка связи',
  'pay-request': 'Запрос оплаты отправлен',
  'pay-response': 'Ответ на запрос оплаты получен',
  'terminal-shown': 'Окно показало «приложите карту»',
  'receipt-shown': 'Окно показало «чек пробит»',
  done: 'Продажа завершена',
  retry: 'Повтор',
}

export function stageWords(source: TraceSource, stage: string): string {
  return source === 'browser' ? (BROWSER_STAGE_WORDS[stage] ?? stage) : stage
}

/**
 * Настройки кассы, которые по плану RP-SALE-TRACE могут замедлять чек. Это предположение, не доказанное замером:
 * пометка так и сформулирована («может»). Список — свойство предметной области, а не данные одной продажи.
 */
export const SETTING_NOTES = {
  acquiringSlipsCount: 'каждая копия слипа — лишняя печать на каждом чеке',
  receiptCompactCheck: 'без компактной печати чек печатается дольше',
  hasAdvertisingLines: 'рекламные строки печатаются на каждом чеке',
  acquiringLockFn: 'накопитель выключается и включается заново при каждом эквайринге — это секунды',
  isStandbyModeEnabled: 'касса «просыпается» по команде — возможная задержка доставки кабинет → касса',
} as const
